export const trackMenuSelection = (menuName, menuId) => {
  if (window.gtag) {
    window.gtag('event', 'menu_selection', {
      menu_name: menuName,
      menu_id: menuId,
    });
  }
};

export const setUserDetails = (userId, userData) => {
  if (window.gtag) {
    // Establecer user_id globalmente
    window.gtag('set', { user_id: userId });

    // Establecer user properties (la forma correcta en GA4)
    window.gtag('set', 'user_properties', {
      email: userData?.email || '(no disponible)',
      name: userData?.name || '(no disponible)',
      username: userData?.preferred_username || '(no disponible)',
    });

    // También enviar config con user_id para asegurar asociación
    window.gtag('config', 'G-X4PRKRY15D', {
      user_id: userId,
      send_page_view: false,
    });
  }
};
